import { ChainId } from '@shared/utils/config/networks';
import { toast } from 'sonner';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import { shortAddr } from '@/lib/misc/utils';
export default function TransferSharedData({
  isAddressOwner,
  txItem
}) {
  return <div className='space-y-4 mt-4' data-sentry-component="TransferSharedData" data-sentry-source-file="TransferSharedData.tsx">
      <div className='flex w-full justify-between'>
        <p className='text-[14px] text-genius-cream/50'>Status</p>
        <p className={`text-[14px] capitalize ${txItem.result.decodedResponse?.transferTransaction && txItem.result.decodedResponse.transferTransaction.status === 'success' ? 'text-green-400' : 'text-red-400'}`}>
          {txItem.result.decodedResponse?.transferTransaction && txItem.result.decodedResponse.transferTransaction.status === 'success' ? 'Success' : 'Failed'}
        </p>
      </div>
      <div className='flex w-full justify-between'>
        <p className='text-[14px] text-genius-cream/50'>Date</p>
        <p className='text-[14px]'>
          <span className='text-genius-cream/50'>
            {new Date(txItem.created_at).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          })}{' '}
            on{' '}
          </span>{' '}
          {new Date(txItem.created_at).toLocaleDateString('en-US', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        })}
        </p>
      </div>
      <div className='flex w-full justify-between'>
        <p className='text-[14px] text-genius-cream/50'>Network</p>
        <p className='text-[14px] capitalize flex items-center'>
          <ImageWithFallback src={getNetworkLogo(txItem?.chain_id)} alt='network' width={18} height={18} className='rounded-md mr-1' data-sentry-element="ImageWithFallback" data-sentry-source-file="TransferSharedData.tsx" />
          {ChainId[txItem.chain_id]}
        </p>
      </div>
      <div className='flex w-full justify-between'>
        <p className='text-[14px] text-genius-cream/50'>
          {isAddressOwner ? 'Your Receiving Address' : 'Sent From'}
        </p>
        <p onClick={() => {
        const addr = isAddressOwner ? txItem?.to_address : txItem?.from_address;
        navigator.clipboard.writeText(addr);
        toast.info('Successfully copied to clipboard!');
      }} className='text-[14px] capitalize flex items-center underline'>
          {isAddressOwner ? shortAddr(txItem?.to_address) : shortAddr(txItem?.from_address)}
        </p>
      </div>
    </div>;
}